<template>
  <van-popup v-model="showError" :close-on-click-overlay="false">
    <div class="error">
      <div class="user-info">
        <div class="user-avatar" :style="{
          backgroundImage: 'url(' + user.headimgurl + ')'
        }"></div>
        <div class="user-name">{{ user.nickname }}</div>
      </div>
      <div class="content">
        <img src="@/assets/GMError.jpeg" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Err',
  computed: {
    ...mapState(['user']),
    showError() {
      return this.user.user_status !== 1;
    }
  },
}
</script>
<style lang="scss" scoped>
.error {
  width: 90vw;
  padding: 6px 12px;

  .user-info {
      display: flex;
      align-items: center;
      flex-direction: column;
  
      .user-avatar {
        width: 60px;
        height: 60px;
        border-radius: 30px;
        margin: 20px 0 20px 0;
        background-size: cover;
        background-position: center;
      }
  
      .user-name {
        font-size: 18px;
        font-weight: 400;
      }
    }

  .content {
    padding: 6px 0;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    img {
      max-width: 100%;;
    }
  }
}
</style>
